import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Owners from "@/pages/Owners";
import OwnerDetail from "@/pages/OwnerDetail";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Tenants from "@/pages/Tenants";
import TenantDetail from "@/pages/TenantDetail";
import Contracts from "@/pages/Contracts";
import Cobranza from "@/pages/Cobranza";
import Commissions from "@/pages/Commissions";
import Bancos from "@/pages/Bancos";
import Depositos from "@/pages/Depositos";
import Juridico from "@/pages/Juridico";
import JuridicoDetail from "@/pages/JuridicoDetail";
import RRHH from "@/pages/RRHH";
import EmployeeDetail from "@/pages/EmployeeDetail";
import Flotilla from "@/pages/Flotilla";
import VehicleDetail from "@/pages/VehicleDetail";
import Agenda from "@/pages/Agenda";
import Licencias from "@/pages/Licencias";
import CompanyUsers from "@/pages/CompanyUsers";
import PagoRetorno from "@/pages/PagoRetorno";
import { useAuth } from "@/context/AuthContext";
import { landingPath } from "@/lib/perms";

function RoleHome() {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={landingPath(user)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pago/retorno" element={<ProtectedRoute><PagoRetorno /></ProtectedRoute>} />
          <Route
            element={
              <ProtectedRoute>
                <Shell />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/propietarios" element={<Owners />} />
            <Route path="/propietarios/:id" element={<OwnerDetail />} />
            <Route path="/inmuebles" element={<Properties />} />
            <Route path="/inmuebles/:id" element={<PropertyDetail />} />
            <Route path="/arrendatarios" element={<Tenants />} />
            <Route path="/arrendatarios/:id" element={<TenantDetail />} />
            <Route path="/contratos" element={<Contracts />} />
            <Route path="/cobranza" element={<Cobranza />} />
            <Route path="/comisiones" element={<Commissions />} />
            <Route path="/bancos" element={<Bancos />} />
            <Route path="/depositos" element={<Depositos />} />
            <Route path="/juridico" element={<Juridico />} />
            <Route path="/juridico/:id" element={<JuridicoDetail />} />
            <Route path="/rrhh" element={<RRHH />} />
            <Route path="/rrhh/:id" element={<EmployeeDetail />} />
            <Route path="/vehiculos" element={<Flotilla />} />
            <Route path="/vehiculos/:id" element={<VehicleDetail />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/licencias" element={<Licencias />} />
            <Route path="/usuarios" element={<CompanyUsers />} />
          </Route>
          <Route path="*" element={<RoleHome />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
